import { GameConfig } from '../config/types';
import { ALL_GAMES } from '../config/games';
import { TeamId } from '../types/teams';

export function getGameConfig(gameType: string | undefined | null): GameConfig | undefined {
  if (!gameType) return undefined;
  return ALL_GAMES.find((g) => g.id === gameType);
}

export function gameUsesTeams(gameType: string | undefined | null): boolean {
  return !!getGameConfig(gameType)?.usesTeams;
}

/** Minimum players per team before start (from GameConfig.minPlayersPerTeam). */
export function getMinPlayersPerTeam(gameType: string | undefined | null): number {
  return getGameConfig(gameType)?.minPlayersPerTeam ?? 2;
}

export function getTeamStartBlockReason(
  players: Array<{ teamId?: TeamId; connected?: boolean }>,
  gameType: string | undefined | null
): string | null {
  if (!gameUsesTeams(gameType)) return null;

  // Match BE validateTeamStart: only connected players gate start.
  const active = players.filter((p) => p.connected !== false);
  if (active.length === 0) return 'needPlayers';

  const unassigned = active.filter((p) => !p.teamId);
  if (unassigned.length > 0) return 'unassigned';

  const min = getMinPlayersPerTeam(gameType);
  const countA = active.filter((p) => p.teamId === 'A').length;
  const countB = active.filter((p) => p.teamId === 'B').length;
  if (countA < min || countB < min) return 'unbalanced';

  return null;
}
